export const handleEnterSubmitForm = e => {
    e.preventDefault();
    return;
};

/**
* Stop enter submitting the form.
* @param keyEvent Event triggered when the user presses a key.
*/
export function onKeyDown(keyEvent: React.KeyboardEvent) {
 if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
   keyEvent.preventDefault();
 }
} 
